import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

/* Project */
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';
import DatePicker from 'commons/components/DatePicker';
import TimePicker from 'commons/components/TimePicker';

function CompleteModal(props) {
  const { toggleForm, isOpen, submit } = props;
  const { t } = useTranslation();
  
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [time, setTime] = useState(moment().format('HH:mm'));

  useEffect(() => {
    if (isOpen) {
      setDate(moment().format('YYYY-MM-DD'));
      setTime(moment().format('HH:mm'));
    }
  }, [isOpen]);

  const handleConfirm = () => {
    const combined = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
    const arrivalAt = combined.isValid() ? combined.toISOString() : moment().toISOString();
    submit(arrivalAt);
  };

  return (
    <Dialog fullWidth onClose={toggleForm} aria-labelledby="simple-dialog-title" open={isOpen} maxWidth="sm">
      <DialogTitle>{t('Finalizar Agendamiento')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ marginBottom: '16px' }}>
              {t('Por favor, ingrese la fecha y hora de recepción para finalizar la agenda:')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              fullWidth
              label={t('Fecha de Recepción')}
              value={date}
              onChange={(e, val) => setDate(val || e?.target?.value || e)}
              name="arrivalDate"
              inputId="arrivalDate"
              type="date"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TimePicker
              fullWidth
              label={t('Hora de Recepción')}
              value={time}
              onChange={(e, val) => setTime(val || e?.target?.value || e)}
              name="arrivalTime"
              inputId="arrivalTime"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleForm} color="primary">
          {t('Cancelar')}
        </Button>
        <ButtonWithLoader onClick={handleConfirm} autoFocus color="primary" variant="contained">
          {t('Finalizar Agendamiento')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default CompleteModal;
